import {AND, COND, OP} from "./RuleObjectTypes";


export function filterReducer(state, action) {
    switch (action.type) {
        case "SET_FILTERS":
            return { localFilters: action.filters };
        case "UPDATE_ATTR":
            return updateAttributeInCondition(state, action);
        case "UPDATE_LOV_ID":
            return updateLovID(state, action);
        case "UPDATE_CONDITION_OP":
            return updateConditionOp(state, action);
        case "UPDATE_OP":
            return updateOp(state, action);
        case "ADD_FILTER_CONDITION":
            return addFilterCondition(state, action);
        case "REMOVE_FILTER_CONDITION":
            return removeFilterCondition(state, action);
        default:
            return null;
    }
}

function updateAttributeInCondition(state, action) {
    let { localFilters } = state;
    let { attrID, attrName, AttrValueId, AttrValueName, ...rest } = localFilters[
        action.position
        ];
    localFilters[action.position] = {
        attrID: action.attrID,
        attrName: action.attrName,
        AttrValueId: 0,
        AttrValueName: "",
        ...rest
    };
    return { localFilters };
}

function updateLovID(state, action) {
    let { localFilters } = state;
    let { AttrValueId, AttrValueName, ...rest } = localFilters[action.position];
    localFilters[action.position] = {
        AttrValueId: action.AttrValueId,
        AttrValueName: action.AttrValueName,
        ...rest
    };
    return { localFilters };
}

function updateConditionOp(state, action) {
    let { localFilters } = state;
    let { conditionOperator, conditionOpName, ...rest } = localFilters[
        action.position
        ];
    localFilters[action.position] = {
        conditionOperator: action.conditionOperator,
        conditionOpName: action.conditionOpName,
        ...rest
    };
    return { localFilters };
}

function updateOp(state, action) {
    let { localFilters } = state;

    localFilters[action.position] = { type: OP, value: action.value };
    return { localFilters };
}

function addFilterCondition(state, action) {
    let { localFilters } = state;
    let toAdd = [
        { type: OP, value: AND },
        { type: COND, attrID: 0, AttrValueId: 0, conditionOperator: 0 }
    ];
    localFilters.splice(action.position + 1, 0, ...toAdd);
    return { localFilters };
}

function removeFilterCondition(state, action) {
    let { localFilters } = state;
    if (action.position === 0) {
        localFilters.splice(action.position, 2);
    } else localFilters.splice(action.position - 1, 2);
    return { localFilters };
}

